import React, { useState, useEffect ,useRef} from "react"
import MetaTags from "react-meta-tags"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import { withRouter } from "react-router-dom"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import Select from "react-select"
import { useSelector } from "react-redux"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import Modal from "react-bootstrap/Modal"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"

import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Table,
  Spinner,
  Input,
  //Badge,
  //FormGroup,
  //UncontrolledTooltip,

  // CardTitle
} from "reactstrap"
import * as acquireAction from "../../store/bGVhZG9jY3VycmVk/actions"
import api from "helpers/Api"
import SimpleReactValidator from "simple-react-validator"

const LeadAcquiredDetails = (props) => {
  const title = "Lead Acquired"

  const { dispatch, searchBtnStyle } = props
  const [typeList, setTypeList] = useState(1)
  useEffect(() => {
    const acquire = { actionMainType: 1, page: 1, limit: 50 }
    setTypeList(1)
    dispatch(acquireAction.loadEmployee())
    dispatch(acquireAction.loadConvertedList(acquire))
    dispatch(acquireAction.loadRecordsMetaData())
  }, [1])
// dispatch(acquireAction.loadConvertedList({ actionMainType: 1, page: 1, limit: 50 }))
  const update = useSelector((state) => state.leadoccurred)
  console.log(update, "update")

  const {
    employee_list = [],
    acquired_list = [],
    obsMetaData = {},
    converted_list = [],
  } = update
  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()
  console.log(converted_list)
  //date format from session
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  // filter form initial state
  const [occurredData, setOccurredData] = useState({
    fromDate: "",
    toDate: "",
  })
  //handle change
  const handleChange = async (e) => {
    setOccurredData({ ...occurredData, [e.target.name]: e.target.value })
  }
  //dropdown initial state
  const [employee, setEmployee] = useState([])
  const [types, setTypes] = useState([])
  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })
  console.log(employee_list, "employeeee")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }
  const [agentKey, setAgentKey] = useState(false)
  const resetForm = () => {
    handleHideMessages()
    setOccurredData({
      fromDate: "",
      toDate: "",
    })
    setSearchFilter("")
    setTypes([])
    setEmployee([])
    setAgentKey(true)
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    setTypeList(1)
    dispatch(acquireAction.loadConvertedList(
      { actionMainType: 1, 
        page: 1,
        limit: 50 }))
  }
  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [loading, setLoading] = useState(false)
  //filter
  const applyFilter = () => {
    if (simpleValidator.current.allValid()) {
    var searchEmployee = employee && employee ? employee.value : ""

    var searchFromDate =
      occurredData && occurredData.fromDate
        ? moment(occurredData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      occurredData && occurredData.toDate
        ? moment(occurredData.toDate).format("YYYY-MM-DD")
        : ""
    var searchType = types && types ? types.value : ""
    var searchFilter = {}
    searchFilter.page = pageChange ? pageCount : 1
    searchFilter.limit = 50
    if (employee) {
      searchFilter.agentId = searchEmployee
    }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchType) {
      searchFilter.actionMainType = searchType
    }
    setTypeList(searchType)
    if (searchType === 1) {
      dispatch(acquireAction.loadConvertedList(searchFilter))
      setBtnLoader(true)
      setTimeout(() => {
        setBtnLoader(false)
      }, 2000)
    }
    if (searchType === 2 || searchType === 3) {
      dispatch(acquireAction.loadLeadConvertedList(searchFilter))
      setBtnLoader(true)
      setTimeout(() => {
        setBtnLoader(false)
      }, 2000)
    }}
    else{
      simpleValidator.current.showMessages()
      forceUpdate(1)
    }

    console.log("filter values", applyFilter)
  }
  const [renderPage,setRenderPage] = useState(false)
  const handleHideMessages = () => {
   
    setRenderPage(!renderPage)
    simpleValidator.current.hideMessages()
   
  }
  console.log(dateFormat, "dateformat")
  //state for attachment modal
  const [attachmentData, setAttachmentData] = useState("")
  const [attachmentModal, setAttachmentModal] = useState(false)
  const [followUpCountModal, setFollowUpCountModal] = useState(false)
  const [countData, setCountData] = useState("")
  console.log(followUpCountModal)
  console.log(countData)

  const [convertCountData, setConvertCountData] = useState("")
  const [convertFollowUpModal, setConvertFollowUpModal] = useState(false)
  //dataTable
  let slNo = 0
  const occurredDataTable =
    typeList === 1 && !isEmpty(acquired_list.data)
      ? acquired_list.data.map((data, index) => {
        slNo = slNo + 1

        const colorCode =
          !isEmpty(obsMetaData) &&
            data.obsStatus &&
            obsMetaData.processStatusOptions &&
            obsMetaData.processStatusOptions.length > 0
            ? obsMetaData.processStatusOptions.find(
              (_) => _.value == data.obsStatus
            ) &&
            obsMetaData.processStatusOptions.find(
              (_) => _.value == data.obsStatus
            )
            : ""
        console.log(colorCode, "colorCOde")
        return {
          key: index,
          sNo: slNo,
          company: data.companyName
            ? data.companyName.map((m) => m).join(",")
            : "--",
          branch: data.branchName
            ? data.branchName.map((m) => m).join(",")
            : "--",
          agentName: data.agentName,
          date: data.Date ? moment(data.Date).format(dateFormat) : "_",
          leadNo: data.leadNo,
          clientCode: data.clientCode,
          contactNo: data.contactNo,
          clientName: data.clientName,
          leadSource: data.leadSource,
          cpCompany: data.cpCompany,
          cpBranch: data.cpBranch,
          cpService: data.cpService,
          cpLeadNo: data.cpLeadNo,
          cpDate:data.cpCreatedAt?moment(data.cpCreatedAt).format(dateFormat):"--",

          attachment: (
            <a
              onClick={() => {
                setAttachmentModal(true)
                setAttachmentData(data.attachment)
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                View Attachments
              </span>
            </a>
          ),
          noOfFollowUp: (
            <div className="d-flex">
              <span className=" badge bg-danger  rounded-circle p-2">
                {data.followupDatasCount}
              </span>
              <i
                className="fas fa-eye icon-btn"
                style={{
                  color: "#50a5f1",
                  marginTop: "4px",
                  marginLeft: "10px",
                }}
                onClick={() => {
                  setFollowUpCountModal(true)
                  setCountData(data.followupDatas)
                }}
              ></i>
            </div>
          ),
          salesUrge:data.salesUrge?data.salesUrge:"--",
          obsStatus: (
            <button
              style={{
                background: !isEmpty(colorCode) && colorCode.colorCode ? colorCode.colorCode : "",
                border: "none",
                cursor: "pointer",
                color: "white",
                padding: "2px",
                borderRadius: "4px",
              }}
            >
              {data.obsStatusName}
            </button>
          ),
        }
      }): typeList === 1 && isEmpty(acquired_list.data)?[]:
       !isEmpty(converted_list.data)
        ? converted_list.data.map((data, index) => {
          slNo = slNo + 1

          const colorCode =
            !isEmpty(obsMetaData) &&
              data.obsStatus &&
              obsMetaData.processStatusOptions &&
              obsMetaData.processStatusOptions.length > 0
              ? obsMetaData.processStatusOptions.find(
                (_) => _.value == data.obsStatus
              ) &&
              obsMetaData.processStatusOptions.find(
                (_) => _.value == data.obsStatus
              )
              : ""
          console.log(colorCode, "colorCOde")
          return {
            key: index,
            sNo: slNo,
            company: data.companyName ? data.companyName : "--",
            branch: data.branchName ? data.branchName : "--",
            agentName: data.agentName,
            date: data.Date ? moment(data.Date).format(dateFormat) : "_",
            leadNo: data.leadNo,
            clientCode: Array.isArray(data.clientCode)
            ? data.clientCode.join(",")
            : typeof data.clientCode === 'string'
              ? data.clientCode
              : "--",
            contactNo: data.contactNo,
            clientName: data.clientName,
            leadSource: data.leadSource,
            cpCompany: data.cpCompany,
            cpBranch: data.cpBranch,
            cpService: data.cpService,
            cpLeadNo: data.cpLeadNo,
            cpDate: Array.isArray(data.cpCreatedAt) && data.cpCreatedAt.length > 0
              ? moment(data.cpCreatedAt.map(m => m).join()).format(dateFormat)
              : typeof data.cpCreatedAt === 'string' && data.cpCreatedAt.trim() !== ''
                ? moment(data.cpCreatedAt).format(dateFormat)
                : "--",
            attachment: (
              <a
                onClick={() => {
                  setAttachmentModal(true)
                  setAttachmentData(data.attachment)
                }}
              >
                <span
                  style={{
                    textDecoration: "underline",
                    color: "#E40D8C",
                  }}
                >
                  View Attachments
                </span>
              </a>
            ),
            noOfFollowUp: (
              <div className="d-flex">
                <span className=" badge bg-danger  rounded-circle p-2">
                  {data.followupDatasCount}
                </span>
                <i
                  className="fas fa-eye icon-btn"
                  style={{
                    color: "#50a5f1",
                    marginTop: "4px",
                    marginLeft: "10px",
                  }}
                  onClick={() => {
                    setConvertFollowUpModal(true)
                    setConvertCountData(data.followupDatas)
                  }}
                ></i>
              </div>
            ),
            obsStatus: (
              <button
                style={{
                  background: !isEmpty(colorCode) && colorCode.colorCode ? colorCode.colorCode : "",
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {data.obsStatusName}
              </button>
            ),
          }
        })
        : []

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "company",
      text: "Company",
      hidden: typeList === 1 ? true : false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      hidden: typeList === 1 ? true : false,
      sort: true,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "date",
      text: "Date",
      csvType: Number,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden:  false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      hidden: typeList === 1 ? true : false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",

      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "contactNo",
      text: "Contact No",
      csvType: Number,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "agentName",
      text: "Agent Name",

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "leadSource",
      text: "Lead Source",

      headerStyle: {
        minWidth: "150px",
      },
    },
     {
      dataField: "cpLeadNo",
      text: "Cp Lead No",
      hidden: typeList === 1 ? false : true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpDate",
      text: "Cp Date",
      hidden: typeList === 1 ? false : true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpCompany",
      text: "Cp Company",

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpBranch",
      text: "Cp Branch",

      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpService",
      text: "Cp Service",
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      hidden: typeList === 1 ? false : true,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpLeadNo",
      text: "Cp Lead No",
      hidden: typeList === 1 ? true : false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "cpDate",
      text: "Cp Date",
      hidden: typeList === 1 ? true : false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "attachment",
      text: "Attachment",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "noOfFollowUp",
      text: "No Of Followup",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "obsStatus",
      text: "OBS status",
      csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
  ]
  //download feature in data table
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
 
  const exportToCsv = () => {
    var searchEmployee = employee && employee ? employee.value : ""

    var searchFromDate =
      occurredData && occurredData.fromDate
        ? moment(occurredData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      occurredData && occurredData.toDate
        ? moment(occurredData.toDate).format("YYYY-MM-DD")
        : ""
    var searchType = types && types ? types.value : ""
    var searchFilter = {}
  
    if (employee) {
      searchFilter.agentId = searchEmployee
    }
    if (searchFromDate) {
      searchFilter.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.toDate = searchToDate
    }
    if (searchType) {
      searchFilter.actionMainType = searchType
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    const apiEndpoint = types.value == 2 ||types.value == 3 ?
    `/get_all_lead_obs_lead_converted`:`/get_obs_lead_converted`
    const cleanPayload = Object.fromEntries(
      Object.entries(searchFilter).filter(([key, value]) => {
        return key !== undefined && value !== undefined
      })
    )
    const payload =Object.keys(cleanPayload).length === 0
    ? { actionMainType: 1 }
    : cleanPayload
     console.log(payload)
    api
      .post(apiEndpoint,payload)
      .then((response) => {
        const rejectExportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data,index) => {

            const cpLeadNo = data.cpLeadNo?JSON.stringify(data.cpLeadNo).replace(
              /","/g,
              "\n"
            ):"--"
           const cpCompany = data.cpCompany?JSON.stringify(data.cpCompany).replace(
            /","/g,
            "\n"
          ):"--"
           const cpBranch = data.cpBranch?JSON.stringify(data.cpBranch).replace(
            /","/g,
            "\n"
          ):"--"
          // data.cpService
          const cpService = data.cpService?JSON.stringify(data.cpService).replace(
            /","/g,
            "\n"
          ):"--"
          return {
            key: index,
            sNo:index+1,
            company: data.companyName ? data.companyName : "--",
            branch: data.branchName ? data.branchName : "--",
            agentName: data.agentName,
            date: data.Date ? moment(data.Date).format(dateFormat) : "_",
            leadNo: data.leadNo,
            clientCode: Array.isArray(data.clientCode)
            ? data.clientCode.join(",")
            : typeof data.clientCode === 'string'
              ? data.clientCode
              : "--",
            contactNo: data.contactNo,
            clientName: data.clientName,
            leadSource: data.leadSource,
            cpCompany: cpCompany,
            cpBranch:cpBranch,
            cpService: cpService,
            salesUrge:data.salesUrge?data.salesUrge:"--",
            cpLeadNo: cpLeadNo,
            cpDate: Array.isArray(data.cpCreatedAt) && data.cpCreatedAt.length > 0
              ? moment(data.cpCreatedAt.map(m => m).join()).format(dateFormat)
              : typeof data.cpCreatedAt === 'string' && data.cpCreatedAt.trim() !== ''
                ? moment(data.cpCreatedAt).format(dateFormat)
                : "--",
           
            noOfFollowUp:data.followupDatasCount?data.followupDatasCount:0,
         
            obsStatus:data.obsStatusName?data.obsStatusName:"--",

            /////
           
            
          }
          })
          : []
        setTimeout(() => {
          let headerData = [
            `SNo,${
              types.value != 1?"Company,Branch,":""
               
            }Date,Lead No,${
              types.value != 1?"Client Code,":""
               
            }Client Name,Contact No,Agent Name,Lead Source, ${
              types.value != 1?"":"CP Lead No,CP Date,"
               
            }CP Company,CP Branch,CP Service,Sales Urge, ${
              types.value != 1
                ? "CP Lead No,CP Date,"
                : ""
            } No of Followup,OBS Status`,
          ]

          let usersCsv = rejectExportDataTable.reduce((acc, user) => {
            if (types.value != 1) {
              const {
                sNo,
                company,
                branch,
                date,
                leadNo,
                clientCode,
                clientName,
                contactNo,
                agentName,
                leadSource,
                cpCompany,
                cpBranch,
                cpService,
                cpLeadNo,
                cpDate,
                noOfFollowUp,
                obsStatus
              } = user
              acc.push([
                sNo,
                company,
                branch,
                date,
                leadNo,
                clientCode,
                clientName,
                contactNo,
                agentName,
                leadSource,
                cpCompany,
                cpBranch,
                cpService,
                cpLeadNo,
                cpDate,
                noOfFollowUp,
                obsStatus
              ])}else{
                const {
                  sNo,
                date,
                leadNo,
                clientName,
                contactNo,
                agentName,
                leadSource,
                cpLeadNo,
                cpDate,
                cpCompany,
                cpBranch,
                cpService,
                 salesUrge,
                noOfFollowUp,
                obsStatus
                } = user
                acc.push([
                  sNo,
                date,
                leadNo,
                clientName,
                contactNo,
                agentName,
                leadSource,
                cpLeadNo,
                cpDate,
                cpCompany,
                cpBranch,
                cpService,
                salesUrge,
                noOfFollowUp,
                obsStatus
                ])


              }

              return acc
            }, [])
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ObsAcquired.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 1000)
        return response.data
      })
      .catch((error) => {
        Promise.reject(error)
        setDownloadLoading(false)
      })
  }

  //list pagination
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                       
                      </Col>

                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >

                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Col>
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                          </Col>

                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          noDataIndication={"No Data Found..."}
                          responsive
                          striped={true}
                          wrapperClasses="table-responsive"
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    if (typeList === 1) {
      dispatch(acquireAction.loadConvertedList({
        searchFilter: searchInput,
        actionMainType :1,
        page: page,
        limit: sizePerPage
      }))
     
    }
    else if (typeList === 2 || typeList === 3) {
      dispatch(acquireAction.loadLeadConvertedList({
        searchFilter: searchInput,
        actionMainType :types.value,
        page: page,
        limit: sizePerPage
      }))
     
    }else{
      dispatch(acquireAction.loadConvertedList({
        searchFilter: searchInput,
        actionMainType :1,
        page: page,
        limit: sizePerPage
      }))
    }

    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: occurredDataTable.length,
    data:
      !isEmpty(occurredDataTable) && occurredDataTable.length > 0
        ? occurredDataTable.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(occurredDataTable) && occurredDataTable.length > 0
        ? occurredDataTable
        : []
    if (
      !isEmpty(occurredData.fromDate) ||
      !isEmpty(occurredData.toDate) ||
      !isEmpty(types) ||
      !isEmpty(employee)
    ) {
      //////////////////////
      var searchEmployee = employee && employee ? employee.value : ""

      var searchFromDate =
        occurredData && occurredData.fromDate
          ? moment(occurredData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        occurredData && occurredData.toDate
          ? moment(occurredData.toDate).format("YYYY-MM-DD")
          : ""
      var searchType = types && types ? types.value : ""
      var searchFilter = {}
      searchFilter.page = page
      searchFilter.limit = 50
      if (employee) {
        searchFilter.agentId = searchEmployee
      }
      if (searchFromDate) {
        searchFilter.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchFilter.toDate = searchToDate
      }
      if (searchType) {
        searchFilter.actionMainType = searchType
      }
      // setTypeList(searchType)
      if (searchType === 1) {
        dispatch(acquireAction.loadConvertedList(searchFilter))

      }
      if (searchType === 2 || searchType === 3) {
        dispatch(acquireAction.loadLeadConvertedList(searchFilter))

      }
      ////////////////////
      setPageLoad(!pageLoad)
      setLoading(true)
    }
    else {

      dispatch(acquireAction.loadConvertedList({ actionMainType: 1, page: 1, limit: 50 }))
      setLoading(true)

    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)


    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Obs"} breadcrumbItem={title} />
        </Container>
        {/**Filter Form Start */}
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"From Date"}>
                          {"CP From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="fromDate"
                        value={occurredData.fromDate}
                        max={occurredData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"To Date"}>
                          {"CP To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="toDate"
                        value={occurredData.toDate}
                        min={occurredData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Employee"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="salesAgent"
                        items={agentOptions}
                        key={agentKey}
                        value={employee}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setEmployee(e)}
                        onChange={(e) => setEmployee(e.target.value)}
                        placeholder="Enter Sales Agent"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Type"}</Label>
                      </div>
                      <Select
                        type="text"
                        name="types"
                        value={types}
                        onChange={(e) => setTypes(e)}
                        options={[
                          { label: "Obs", value: 1 },
                          { label: "Other Brand Lead", value: 2 },
                          { label: "Reject Lead", value: 3 },
                        ]}
                        placeholder="Select Type"
                        classNamePrefix="select2-selection"
                      />
                       <div style={{ textTransform: "capitalize" }}>
                          {simpleValidator.current.message(
                            "Type",
                            types,
                            "required"
                          )}
                        </div>
                    </Col>
                  </Row>
                  <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                    <div className="filter-buttons" style={{ float: "right" }}>
                      <Button
                        type="button"
                        onClick={() => resetForm()}
                        className="btn btn-danger btn-label simple-form-Reset-btn"
                      >
                        <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                        Reset
                      </Button>
                      <Button
                        type="button"
                        onClick={() => applyFilter()}
                        className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                      >
                        <i className="bx bx-filter-alt label-icon"></i>
                        {btnLoader && btnLoader ? (
                          <ButtonSpinner />
                        ) : (
                          "Apply Filter"
                        )}{" "}
                      </Button>
                    </div>
                  </Col>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        {/**Table Start */}
        <Col md="12" lg="12" xl="12">
          <Card>
            <CardBody>
            <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
              <RemotePagination
                data={occurredDataTable}
                page={page}
                sizePerPage={sizePerPage}
                totalSize={typeList === 1 ? (acquired_list.totalDataCount ? acquired_list.totalDataCount : 0) :
                   (converted_list.totalDataCount ? converted_list.totalDataCount : 0)}

                onTableChange={handleTableChange}
              />
            </CardBody>
          </Card>
        </Col>
        {attachmentModal && (
          <Modal size="xl" show={attachmentModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              View Attachments
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Attachments</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(attachmentData) && attachmentData ? (
                      attachmentData.map((item, index) => {
                        console.log(item, "item")
                        return (
                          <>
                            <tr key={index}>
                              <td>{index + 1}</td>

                              <td>
                                {(item && item.split(".").pop() === "jpeg") ||
                                  (item && item.split(".").pop() === "jpg") ||
                                  (item && item.split(".").pop() === "png") ? (
                                  <a
                                    onClick={() => window.open(item, "_blank")}
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>
                                ) : (item && item.split(".").pop() === "mp3") ||
                                  (item && item.split(".").pop() === "m4a") ||
                                  (item && item.split(".").pop() === "mp4") ? (
                                  <a href={item}>
                                    <audio controls>
                                      <source src={item} type="audio/mpeg" />
                                      Your browser does not support the audio
                                      element.
                                    </audio>
                                  </a>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={2} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setAttachmentModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {followUpCountModal && (
          <Modal size="xl" show={followUpCountModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th> Date</th>
                      <th>Followup Mode</th>
                      <th>Reach Status</th>
                      <th>Followup Remarks</th>
                      <th>Followup Time</th>
                      <th>Followup No</th>
                      <th>Future Followup Datetime</th>
                      <th>Future Followup</th>
                      <th>Future Followup Strategy</th>
                      <th>Attachment</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(countData) && countData.length > 0 ? (
                      countData.map((item, index) => {
                        const colorCode =
                          !isEmpty(obsMetaData) &&
                          obsMetaData.processStatusOptions &&
                          obsMetaData.processStatusOptions.length > 0 &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ) &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ).colorCode
                        console.log(colorCode, "colorCode")

                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>
                                {moment(item.followUpDate).format(dateFormat)}
                              </td>
                              <td>{item.followupMode}</td>
                              <td>{item.clientReachStatus}</td>
                              <td>{item.followUpRemarks}</td>
                              <td>{item.followUpTime}</td>
                              <td>{item.followupNo}</td>
                              <td>
                                {moment(item.futureFollowUpDateTime).format(
                                  `${dateFormat} hh:mm A`
                                )}
                              </td>
                              <td></td>
                              <td>{item.futureFollowUpStrategy}</td>

                              <td>
                                {!isEmpty(item.recordAttachment) &&
                                  item.recordAttachment
                                  ? item.recordAttachment.map((item, index) => {
                                    console.log(item, "item")
                                    return (
                                      <div key={index}>
                                        {(item &&
                                          item.split(".").pop() === "jpeg") ||
                                          (item &&
                                            item.split(".").pop() === "jpg") ||
                                          (item &&
                                            item.split(".").pop() === "png") ? (
                                          <a
                                            onClick={() =>
                                              window.open(item, "_blank")
                                            }
                                          >
                                            <span
                                              style={{
                                                textDecoration: "underline",
                                                color: "#E40D8C",
                                              }}
                                            >
                                              View
                                            </span>
                                          </a>
                                        ) : (item &&
                                          item.split(".").pop() ===
                                          "mp3") ||
                                          (item &&
                                            item.split(".").pop() ===
                                            "m4a") ||
                                          (item &&
                                            item.split(".").pop() ===
                                            "mp4") ? (
                                          <a href={item}>
                                            <audio controls>
                                              <source
                                                src={item}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support
                                              the audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )
                                  })
                                  : ""}
                              </td>
                              <td>
                                <button
                                  style={{
                                    background: colorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {item.processStatusName}
                                </button>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={10} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setFollowUpCountModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {convertFollowUpModal && (
          <Modal size="xl" show={convertFollowUpModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Followup
            </Modal.Header>
            <Modal.Body>
              <Col md="12" lg="12" xl="12" className="mt-5">
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>S.No</th>

                      <th> Date</th>
                      <th>Followup Mode</th>
                      <th>Reach Status</th>
                      <th>Followup Remarks</th>
                      <th>Followup Time</th>
                      <th>Followup No</th>
                      <th>Future Followupdatetime</th>
                      <th>Future Followup</th>
                      <th>Future Followup Strategy</th>
                      <th>Attachment</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(convertCountData) &&
                      convertCountData.length > 0 ? (
                      convertCountData.map((item, index) => {
                        const colorCode =
                          !isEmpty(obsMetaData) &&
                          obsMetaData.processStatusOptions &&
                          obsMetaData.processStatusOptions.length > 0 &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ) &&
                          obsMetaData.processStatusOptions.find(
                            (_) => _.value === item.processStatus
                          ).colorCode
                        console.log(colorCode, "colorCode")

                        return (
                          <>
                            <tr key={item._id}>
                              <td>{index + 1}</td>

                              <td>
                                {moment(item.followUpDate).format(dateFormat)}
                              </td>
                              <td>{item.followupMode}</td>
                              <td>{item.clientReachStatus}</td>
                              <td>{item.followUpRemarks}</td>
                              <td>{item.followUpTime}</td>
                              <td>{item.followupNo}</td>
                              <td>
                                {moment(item.futureFollowUpDateTime).format(
                                  `${dateFormat} hh:mm A`
                                )}
                              </td>
                              <td></td>
                              <td>{item.futureFollowUpStrategy}</td>

                              <td>
                                {!isEmpty(item.recordAttachment) &&
                                  item.recordAttachment
                                  ? item.recordAttachment.map((item, index) => {
                                    console.log(item, "item")
                                    return (
                                      <div key={index}>
                                        {(item &&
                                          item.split(".").pop() === "jpeg") ||
                                          (item &&
                                            item.split(".").pop() === "jpg") ||
                                          (item &&
                                            item.split(".").pop() === "png") ? (
                                          <a
                                            onClick={() =>
                                              window.open(item, "_blank")
                                            }
                                          >
                                            <span
                                              style={{
                                                textDecoration: "underline",
                                                color: "#E40D8C",
                                              }}
                                            >
                                              View
                                            </span>
                                          </a>
                                        ) : (item &&
                                          item.split(".").pop() ===
                                          "mp3") ||
                                          (item &&
                                            item.split(".").pop() ===
                                            "m4a") ||
                                          (item &&
                                            item.split(".").pop() ===
                                            "mp4") ? (
                                          <a href={item}>
                                            <audio controls>
                                              <source
                                                src={item}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support
                                              the audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )
                                  })
                                  : ""}
                              </td>
                              <td>
                                <button
                                  style={{
                                    background: colorCode,
                                    border: "none",
                                    cursor: "pointer",
                                    color: "white",
                                    padding: "2px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {item.processStatusName}
                                </button>
                              </td>
                            </tr>
                          </>
                        )
                      })
                    ) : (
                      <>
                        <tr key={0}>
                          <td colSpan={10} className="text-align-center">
                            No record found
                          </td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </Table>
              </Col>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setConvertFollowUpModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {loading ? (
          <Modal show={loading} style={{ width: "7%", margin: "18% 50%" }}>
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
          {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
      </div>
    </React.Fragment>
  )
}
LeadAcquiredDetails.propTypes = {
  dispatch: PropTypes.func,
  //recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  name: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  FlagExportExcel: PropTypes.any,
  FlagImportInward: PropTypes.any,
  FlagTableSearch: PropTypes.any,
  columns: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LeadAcquiredDetails)
)
